module.exports = __webpack_public_path__ + "assets/3cec3c655b5d3594ba4a26c011cb1dff.mp3";